<script lang="ts" setup>
	import type {HTMLAttributes} from 'vue';
	import {cn} from '@/scripts/utils/utils';
	import {Primitive, type PrimitiveProps} from 'radix-vue';

	const props = withDefaults(
		defineProps<PrimitiveProps & {class?: HTMLAttributes['class']}>(),
		{
			as: 'a',
		}
	);
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="cn('hover:text-foreground transition-colors', props.class)"
	>
		<slot />
	</Primitive>
</template>
